module.exports = __webpack_public_path__ + "img/image82.de1ea392.jpg";